/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Property_DeleteInputs */

const cs_audit_key_property_delete = /** @type {(inputs: Audit_Key_Property_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost smazána`)
};

const en_audit_key_property_delete = /** @type {(inputs: Audit_Key_Property_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property deleted`)
};

/**
* | output |
* | --- |
* | "Property deleted" |
*
* @param {Audit_Key_Property_DeleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_property_delete = /** @type {((inputs?: Audit_Key_Property_DeleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Property_DeleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_property_delete(inputs)
	return cs_audit_key_property_delete(inputs)
});